<template>
  <div >
    <div v-if="!radioButtons">
      <address-round-container
      v-on:delete="areYouSureToDelete($event)"
      v-on:edit="openEditModal($event)"
      v-for="address in shippingAddressesSaved"
      :key="address.id"
      :address="address" />
    </div>
    <div v-else class="overflow-y-auto max-h-200">
      <h3>{{ $t('checkout.selectAddress') }}</h3>
      <div class="w-full text-left flex items-center" v-if="billingInList">
        <input type="radio" v-model="selectedAddress" :value="billingAddress" :aria-label="$t('checkout.selectAddress')" role="checkbox">
        <address-round-container
          class="w-full ml-4"
          :address="billingAddress"
          @delete="areYouSureToDelete($event)"
          @edit="openEditModal($event)" />
      </div>

      <div
        class="w-full text-left flex items-center"
        v-for="address in shippingAddressesSaved"
        :key="address.id">
        <input type="radio" v-model="selectedAddress" :value="address" :aria-label="$t('checkout.selectAddress')" role="checkbox">
        <address-round-container
          class="w-full ml-4"
          :address="address"
          @delete="areYouSureToDelete($event)"
          @edit="openEditModal($event)" />
      </div>
      <button
        class="shadow-md rounded-md hover:bg-b2c-red-300 hover:text-white p-2 text-sm m-6"
        @click="addAddress()">
          {{$t('checkout.addAddress')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import store from '@/store/index';
import AddressRoundContainer from '@/components/profile/AddressRoundContainer.vue';
// eslint-disable-next-line import/no-cycle
import AddressesMixin from '@/mixins/AddressesMixin';

export default {
  props: ['radioButtons', 'billingInList', 'order'],

  data() {
    return {
      selectedAddress: '',
    };
  },

  watch: {
    selectedAddress() {
      this.$emit('input', this.selectedAddress);
      if (this.order) {
        this.updateOrderAddress();
      }
    },

    newAddress() {
      this.selectedAddress = this.newAddress;
    },
  },

  components: {
    AddressRoundContainer,
  },

  computed: {
    ...mapGetters({
      customer: 'auth/customer',
      billingAddress: 'auth/billingAddress',
      shippingAddressesSaved: 'auth/shippingAddresses',
      newAddress: ['newAddress'],
    }),
  },

  mixins: [AddressesMixin],

  methods: {
    updateOrderAddress() {
      const order = {
        shipping_address_id: this.selectedAddress.id,
      };
      axios.put(`/api/orders/${this.order.order_no}/address`, order).then(() => {
        store.dispatch('cart/updatedOrder');
        this.$emit('close');
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },

  },
};
</script>
